import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

export const WebExposePublishedPayloadSchema = z.object({
  webExposeId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  showAddress: z.boolean(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type WebExposePublishedPayload = z.infer<typeof WebExposePublishedPayloadSchema>;

export const WEB_EXPOSE_WITHDRAWAL_REASONS = ['MEMBER', 'PROPERTY_LEFT_MARKET'] as const;

export const WebExposeWithdrawnPayloadSchema = z.object({
  webExposeId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  reason: z.enum(WEB_EXPOSE_WITHDRAWAL_REASONS),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type WebExposeWithdrawnPayload = z.infer<typeof WebExposeWithdrawnPayloadSchema>;
